import * as Constants from './constants';
import strings from 'owa-strings/owa-sharing-strings';
export default function createSharingMessageActionText(action) {
    switch (action) {
        case Constants.ACCEPT_AND_VIEW_CALENDAR:
            // In React, accepting sharing message is broken into two actions, an "Accept" and then a
            // "View Calendar". So the "Accept and view calendar" button no longer makes sense, so we'll default to
            // just "Accept" instead.
            return strings.acceptAcceptButtonText;
        case Constants.ADD_THIS_CALENDAR:
            return strings.addThisCalendarAcceptButtonText;
        case Constants.VIEW_CALENDAR:
            return strings.viewCalendarAcceptButtonText;
        default:
            /*CalendarSharingAction.Accept is the old default value*/
            return strings.acceptAcceptButtonText;
    }
}
//# sourceMappingURL=createSharingMessageActionText.js.map